"use client"

import { useEffect, useState, memo } from "react"
import MainLayout from "@/layout/MainLayout"
import StandardCard from "@/components/cards/StandardCard"
import { LISTING_GRID_CLASS, renderNewsGridWithAds } from "@/components/ListingGridWithAds"
import { useSearchParams } from "next/navigation"
import axiosInstance from "@/lib/axios"
import PageHeader from "@/components/ui/PageHeader"
import { LISTING_NEWS_PER_PAGE } from "@/lib/advertisement/constants"
import { CardGridSkeleton, EmptyState } from "@/components/ui/Skeleton"
import Pagination from "@/components/ui/Pagination"
import { slugToMarathi } from "@/lib/helper"

const MostReadNews = () => {
    const searchParams = useSearchParams()
    const categorySlug = searchParams.get('category')
    const categoryName = slugToMarathi(categorySlug)

    const [news, setNews] = useState([])
    const [pagination, setPagination] = useState({})
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState(1)

    const fetchMostRead = async (page = 1) => {
        try {
            setLoading(true)
            const response = await axiosInstance.get('/news/most-read', {
                params: { category: categorySlug, page, limit: LISTING_NEWS_PER_PAGE }
            })
            if (response.data.success) {
                setNews(response.data.data)
                setPagination(response.data.pagination)
            }
        } catch (error) {
            console.error("Error fetching most read news:", error)
        } finally {
            setLoading(false)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    useEffect(() => {
        setCurrentPage(1)
    }, [categorySlug])

    useEffect(() => {
        fetchMostRead(currentPage)
    }, [categorySlug, currentPage])

    const title = 'सर्वाधिक वाचलेल्या बातम्या'
    const description = 'संपूर्ण महाराष्ट्रातील सर्वाधिक वाचलेल्या बातम्या.'

    return (
        <MainLayout>
            <PageHeader
                title={title}
                description={description}
                accentName="Most Read"
            />

            {loading && !news.length ? (
                <CardGridSkeleton count={9} />
            ) : news.length > 0 ? (
                <>
                    <div className={LISTING_GRID_CLASS}>
                        {renderNewsGridWithAds(news, 'most_read', (item) => (
                            <StandardCard
                                key={item.id}
                                layout="col"
                                headline={item.title}
                                imageUrl={item.featuredImage}
                                data={item}
                            />
                        ))}
                    </div>

                    {pagination.totalPages > 1 && (
                        <div className="mt-12">
                            <Pagination
                                currentPage={pagination.currentPage}
                                totalPages={pagination.totalPages}
                                onPageChange={setCurrentPage}
                            />
                        </div>
                    )}
                </>
            ) : (
                <EmptyState message="सध्या कोणतीही बातमी उपलब्ध नाही." />
            )}
        </MainLayout>
    )
}

export default memo(MostReadNews)
